import React, { Component } from 'react';
import '../../assets/styles/MainMenu/Item.sass';

class Item extends Component {
  render() {
    let conversion = this.props.conversion;

    return <li className="Item">{conversion}</li>;
  }
}

export default Item;
